import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './rc_timepicker_custom.css'
import './react_calendar_custom.css'
import './react_datepicker_custom.css'
import './select_custom.css'
import './sliders_custom.css'
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import ErrorBoundary from 'components/ErrorBoundary';
import './helpers/localisation';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
);
